import { HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

import { Shortcut } from './components/Shortcut';

export const MyShortcuts = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  return (
    <VStack paddingX={Spacing['stack.xxxs']} space={Spacing['stack.xxxs']}>
      <HStack
        space={Spacing['stack.xxxs']}
        minWidth="max-content"
        flex={1}
        justifyContent={'space-between'}>
        <Shortcut
          label="Resumo financeiro"
          icon="Auc"
          onPress={() => navigate('HomeFinancialSummary')}
        />
        <Shortcut
          label="TOP 15 produtos"
          icon="Medal"
          onPress={() => navigate('HomeTop15Products')}
        />
      </HStack>
    </VStack>
  );
};
